<template>
  <div>
    <div class="grid grid-cols-3 gap-6">
      <div
        v-for="post in posts"
        :key="post.slug"
        class="col-span-3 lg:col-span-1"
      >
        <vetster-pet-connection-post :post="post" />
      </div>
    </div>
    <div class="flex justify-center items-center h-12 mt-6">
      <div v-if="!loadedMore">
        <vetster-button
          class="flex items-center justify-center space-x-1"
          variant="ocean"
          size="xl"
          @click="loadMore"
        >
          <fa :icon="['fal', 'plus']" />
          <span>{{ $t('pets.species.SHOW_MORE') }}</span>
        </vetster-button>
      </div>
      <div
        v-else
        class="flex justify-center items-center"
      >
        <fa
          :icon="['fal', 'circle-notch']"
          class="text-4xl text-neutral-500 fa-spin"
        />
      </div>
    </div>
  </div>
</template>

<script>
import VetsterPetConnectionPost from '@/components/VetsterPetConnectionPost';
import BlogPost from '@/models/BlogPost';

export default {
  name: 'VetsterPetConnectionPosts',

  components: { VetsterPetConnectionPost },

  props: {
    category: {
      type: String,
      default: null,
    },
    postSlugs: {
      type: Array,
      default: () => [],
    },
    species: {
      type: String,
      default: null,
    },
    stage: {
      type: String,
      default: null,
    },
  },

  data() {
    return {
      isLoading: false,
      loadedMore: false,
      page: 1,
      posts: [],
      slugsExcluded: this.postSlugs,
    };
  },

  computed: {
    payload() {
      return {
        'slugs-excluded': this.slugsExcluded,
        page: this.page,
        'pet-connection-category': this.category,
        species: this.species,
        stage: this.stage,
      };
    },
  },

  methods: {
    async loadMore() {
      if (this.loadedMore) {
        return;
      }
      this.loadedMore = true;
      const response = await this.$api.get('/p/blog-post', { params: this.payload });
      response.data.data.forEach((searchResult) => {
        this.slugsExcluded.push(searchResult.slug);
        this.posts.push(new BlogPost(searchResult));
      });
      this.loadedMore = false;
      this.page++;
    },
  },
};
</script>
